export default __webpack_public_path__ + "static/media/logo.909a85f9.svg";